"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addExtraThemeEntries = void 0;
var color_string_1 = __importDefault(require("color-string"));
var cssVariables_1 = require("./cssVariables");
/**
 * Use this to generate an object containing `${key}: value`, `${key}-rgb: r, g, b`, and/or `${key}-id: --color-blah-XXX`.
 * This is for adding extra neighbouring properties to a theme.
 * For example:
 *  Input:
 *    path: [color, purple, 100]
 *    key: 100
 *    value: #f0f1f4
 *    printValue: (path, v) => `var(--some-key, ${v})`
 *    options: {augmentWithId: true}
 *
 *  Output: {
 *    "100": "var(--some-key, #f0f1f4)",
 *    "100-rgb": "var(--some-key, 240, 241, 244)",
 *    "100-id": "--color-purple-100"
 *    "100-rgb-id": "--color-purple-100-rgb"
 *  }
 */
var addExtraThemeEntries = function (path, key, value, printValue, _a) {
    var _b;
    var augmentWithId = _a.augmentWithId;
    var colorRgb = typeof value === "string" ? color_string_1.default.get.rgb(value) : null;
    var result = (_b = {},
        _b[key] = printValue(path, value),
        _b);
    // Add the -rgb key containing the RGB triple of the color (if it is a color)
    if (colorRgb) {
        // If the value is a color, always convert to lowercase
        result[key] = printValue(path, value).toLowerCase();
        var rgbPath = __spreadArray(__spreadArray([], path, true), ["rgb"], false);
        var rgbTriple = printValue(rgbPath, colorRgb.slice(0, 3).join(", "));
        result["".concat(key, "-rgb")] = rgbTriple;
        if (augmentWithId) {
            result["".concat(key, "-rgb-id")] = (0, cssVariables_1.objectPathToCssVarIdentifier)(rgbPath);
        }
    }
    if (augmentWithId) {
        result["".concat(key, "-id")] = (0, cssVariables_1.objectPathToCssVarIdentifier)(path);
    }
    return result;
};
exports.addExtraThemeEntries = addExtraThemeEntries;
//# sourceMappingURL=addExtraThemeEntries.js.map